import { useSelector } from 'react-redux';
import HostedTableFooter from './HostedTableFooter';
import { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { Tooltip } from 'antd';

const HostedTablePreview = ({ cancelForm, setStep }) => {
  const file = useSelector((state) => state.hostedTables.file);
  const delimiter = useSelector((state) => state.hostedTables.delimiter);
  const containsHeader = useSelector((state) => state.hostedTables.containsHeader);
  const [fileContent, setFileContent] = useState([]);
  const [fileHeader, setFileHeader] = useState([]);

  useEffect(() => {
    Papa.parse(file, {
      header: false,
      delimiter,
      dynamicTyping: true,
      complete: function (results) {
        const data = results.data.splice(0, 5);

        if (containsHeader) {
          setFileHeader(data.shift());;
        }
        setFileContent(data);
      },
    });
  }, []);

  return (
    <div className='k-form scroll-content-modal'>
      <div className='ant-table'>
        <div className='ant-table-container' style={{ overflowX: 'auto' }}>
          <table style={{ tableLayout: 'auto' }}>
            {
              fileHeader.length > 0 &&
              <thead className='ant-table-thead'>
                <tr>
                  {
                    fileHeader.map((val, index) => {
                      return (
                        <Tooltip key={`${index}_${String(val).replace(/ /g, "_")}`} placement="topLeft" title={String(val)}>
                          <th className='ant-table-cell ant-table-cell-ellipsis'>{String(val)}</th>
                        </Tooltip>
                      );
                    })
                  }
                </tr>
              </thead>
            }
            <tbody className='ant-table-tbody'>
              {
                fileContent.map((fileContentVal, fileContentIndex) => {
                  return (
                    <tr dataRowKey={fileContentIndex} className={`ant-table-row ant-table-row-level-${fileContentIndex}`} key={fileContentIndex}>
                      {
                        fileContentVal.map((val, index) => {
                          return (
                            <Tooltip key={`${index}_${String(val).replace(/ /g, "_")}`} placement="topLeft" title={String(val)}>
                              <td className='ant-table-cell ant-table-cell-ellipsis'>{String(val)}</td>
                            </Tooltip>

                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
      <HostedTableFooter setStep={setStep} cancelForm={cancelForm} />
    </div>
  );
};

export default HostedTablePreview;
